<template>
  <div class="h-full">
    <!-- Projet non chargé  -->
    <div class="h-full flex flex-col " v-if="!isLoaded">
      <div class="flex items-center justify-between mb-3">
        <div class="flex items-center">
          <span class="text-s tracking-widest font-bold title-font">
            <skeleton-loader-vue
              type="rect"
              :width="200"
              :height="40"
              animation="wave"
              rounded
            />
          </span>
        </div>
        <div class="flex items-center">
          <div class="flex items-center">
            <skeleton-loader-vue
              type="rect"
              :width="200"
              :height="40"
              animation="wave"
              rounded
            />
          </div>
        </div>
      </div>
      <div class="h-full flex flex-col">
        <skeleton-loader-vue
          type="rect"
          :width="1200"
          :height="250"
          animation="wave"
          rounded
        />
        <skeleton-loader-vue
          class="mt-5"
          type="rect"
          :width="1200"
          :height="250"
          animation="wave"
          rounded
        />
      </div>
    </div>

    <!-- Projet chargé -->
    <div class="h-full flex flex-col" v-if="group.project.title && isLoaded">
      <div class="mb-4" :class="isFinish ? 'mode_examen_finish' : 'mode_examen'" v-if="group.project.type === 'examen'">
        <div class="mode_examen_deadline flex py-2">
          <template v-if="!isFinish">
            <v-mdi size="24" name="mdi-folder-clock-outline" class="mr-3"></v-mdi>
            <span class="text_mode mr-3">Mode examen</span>
            <span>-</span>
          </template>
          <v-mdi size="24" name="mdi-clock-outline" class="mr-3 ml-3"></v-mdi>
          <span class="text_mode">{{ messageDateProject }}</span>
        </div>
      </div>
      <div class="flex items-center justify-between mb-4">
        <div>
          <span class="text-ssm:text-3xl lg:text-4xl tracking-widest font-bold title-font">
            {{ group.project.title }}
          </span>
          <template v-if="group.project.type !== 'team'">
            <br />
            <span class="text-ssm:text-xl lg:text-2xl tracking-widest font-bold title-font text-primary">
              {{ group.title }}
          </span>
          </template>
        </div>
        <div class="flex items-center">
          <div class="flex items-center" id="snippet-options" v-if="isAdminOfProject">
            <Button
              @click="$router.push(`/projects/${$route.params.idProject}/settings`)"
              icon="mdi-cog"
              :icon-size="24"
              label="Paramètres"
            />
          </div>
          <div v-else>
            <Button
              @click="leaveProject"
              label="Quitter le projet"
              class="p-button-rounded btn-blue"
              :is-loading="isProjectLeft"
            />
          </div>
          <div v-if="group.project.type === 'examen' || group.project.type === 'teach'">
            <GroupsSideBar :group="group" @send-code="sendCode" :idProject="$route.params.idProject" :idGroup="$route.params.idGroup" />
          </div>
        </div>
      </div>
      <Accordion class="p-mb-5" v-if="group.project.description && group.project.description !== ''">
        <AccordionTab header="Description du projet">
          <div>
            <pre>{{ group.project.description }}</pre>
          </div>
        </AccordionTab>
      </Accordion>
      <div class="h-full" :class="{ previewMaximized: isPreviewMaximized }" v-if="files.length > 0">
        <Splitter
          style="height: 100%; width: 100%; border: none;"
          layout="vertical"
          :gutter-size="isPreviewMaximized ? 0 : 20"
          :key="editorSize"
        >
          <SplitterPanel :size="editorSize" class="editor-panel">
            <code-editor-component
              ref="editor"
              :files="files"
              :firebaseUid="authFirebase.uid"
              :userColor="userColor"
              :readOnly="!canEditCode || disableEditByDate"
              @preview="setupPreview"
            />
          </SplitterPanel>
          <SplitterPanel :size="previewSize">
            <code-preview-component
              :previews="previews"
              :isMaximized="isPreviewMaximized"
              @minimize="onPreviewMinimized"
              @maximize="onPreviewMaximized"
            />
          </SplitterPanel>
        </Splitter>
      </div>
    </div>
  </div>
</template>

<script>
import CodeEditorComponent from '@/components/Snippets/CodeEditorComponent.vue'
import CodePreviewComponent from '@/components/Snippets/CodePreviewComponent.vue'
import GroupsSideBar from '@/components/Snippets/GroupsSidebar.vue'
import axios from "axios"
import moment from "moment"
import { mapGetters } from 'vuex'

import { db } from "@/plugins/firebase"
import { getAuth, signInWithCustomToken, signOut } from "firebase/auth"
import { ref, get, child } from "firebase/database";

export default {
  name: 'EditSnippet',
  components: {
    CodeEditorComponent, CodePreviewComponent, GroupsSideBar,
  },
  data() {
    return {
      group: {
        title: '',
        firebase_key: '',
        project: {
          title: null,
          description: '',
          type: '',
          creator_user_id: null,
          start_date: null,
          end_date: null,
          examenMessage: null
        }
      },
      userColor: '#797EDB',
      authFirebase: null,
      authFirebaseError: false,
      files: [],
      previews: {
        html: '',
        css: '',
        js: ''
      },
      isPreviewMaximized: false,
      editorSize: 60,
      previewSize: 40,
      /** Used to force the preview component as primevue splitter does not rerender children correctly  */
      previewComponentKey: new Date().toISOString(),
      isProjectLeft: false,
      isFinish: false,
      now: Date.now(),
      isLoaded: false
    }
  },
  computed: {
    disableEditByDate() {
      if (this.group.project.type !== "examen") return false

      const startDateNotPassed = moment(this.group.project.start_date).isAfter(moment(this.now))
      const endDatePassed = moment(this.group.project.end_date).isBefore(moment(this.now))

      const conditionProjectAdmin = (member) => member.id === this.$store.state.auth.id && member.pivot.is_admin
      const isUserProjectAdmin = this.group.project.members.some(conditionProjectAdmin)

      return (!isUserProjectAdmin && startDateNotPassed) || endDatePassed
    },
    messageDateProject() {
      moment.locale('fr')
      if (moment(this.group.project.start_date).isAfter(this.now)) {
        this.isFinish = false
        return "Début " + moment(this.group.project.start_date).from(moment(this.now))
      } else if(moment(this.group.project.end_date).isAfter(this.now)) {
        this.isFinish = false
        return "Verrouillage " + moment(this.group.project.end_date).from(moment(this.now))
      } else {
        this.isFinish = true
        return "L'examen est terminé !"
      }
    },
    canEditCode() {
      const conditionGroup = (member) => member.id === this.$store.state.auth.id
      const isUserInGroup = this.group.members.some(conditionGroup)

      const conditionViewer = (member) => member.id === this.$store.state.auth.id && member.role.role_id === 3
      const isUserViewer = this.group.members.some(conditionViewer)

      const conditionProjectAdmin = (member) => member.id === this.$store.state.auth.id && member.pivot.is_admin
      const isUserProjectAdmin = this.group.project.members.some(conditionProjectAdmin)

      return (isUserInGroup || isUserProjectAdmin) && !isUserViewer
    },
    isAdminOfProject() {
      const currentUser = this.group.project.members.find(element => element.id === this.$store.state.auth.id);
      let is_admin = false;
      if(currentUser.pivot.is_admin || this.group.project.creator_user_id === this.$store.state.auth.id) {
        is_admin = true
      }
      return is_admin;
    },
    ...mapGetters("projects", {
      currentProject: "getCurrent",
    })
  },
  methods: {
    onPreviewMaximized() {
      this.isPreviewMaximized = true
      this.editorSize = 0
      this.previewSize = 100
    },
    onPreviewMinimized() {
      this.isPreviewMaximized = false
      this.editorSize = 60
      this.previewSize = 40
    },
    setupPreview(file) {
      this.previews[file.code] = file.content ?? ''
    },
    async updatedCode(e) {
      this.previewComponentKey = new Date().toISOString()
      const file = this.getFileByMimeType(e.filemode)
      file.content = e.filecontent

      await axios.put(`files`, this.files.map((file) => ({
        id: file.id,
        content: file.content,
        mime_type: file.mime_type
      })))
    },
    async leaveProject() {
      this.$confirm.require({
        message: 'Êtes-vous sûr de vouloir quitter ce projet ?',
        header: 'Avant de quitter',
        icon: 'pi pi-exclamation-triangle',
		acceptLabel: 'Oui',
		rejectLabel: 'Non',
        accept: async () => {
          this.isProjectLeft = false
          await axios.delete(`/projects/${this.$route.params.idProject}/leave`)
          this.isProjectLeft = true

          this.$toast.add({
            severity: 'success',
            summary: 'Projet quitté',
            detail: `Vous avez quitté le projet "${this.group.project.title}" avec succès`,
            life: 3000
          })

          await this.$router.push('/dashboard')
        }
      })
    },
    async fetchGroupDetails() {
      try {
        const response = (await axios.get(`groups/${this.$route.params.idGroup}`)).data
        this.group = response.group
        this.userColor = response.color
        await this.$store.dispatch('projects/fetchRecents')
      } catch (error) {
        console.log(error)
        if (error.response.status === 404) {
          await this.$router.push('/erreur/404')
        } else {
          this.$toast.add({
            severity: "error",
            summary: "Impossible de récupérer les informations du groupe",
            detail: "Veuillez réessayer ultérieurement",
            life: 3000,
          })
        }
      }
    },
    async signInFirebase() {
      const auth = getAuth()
      const firebaseToken = this.$store.getters['auth/firebaseToken']
      signInWithCustomToken(auth, firebaseToken)
        .then(async (userCredential) => {
          this.authFirebase = userCredential.user
          this.authFirebaseError = null
          await this.fetchFirebase()
        })
        .catch(async (error) => {
          if (error.code === 'auth/invalid-custom-token') {
            const newFirebaseToken = (await axios.get('me/refresh_firebase_token')).data
            await this.$store.dispatch('auth/updateFirebaseToken', newFirebaseToken)
            if (!this.authFirebaseError) {
              await this.signInFirebase()
              this.authFirebaseError = error
            } else {
              const errorCode = error.code
              const errorMessage = error.message
              console.log(errorCode)
              console.log(errorMessage)
              this.$toast.add({
                severity: "error",
                summary: "Impossible de récupérer le code du groupe (Firebase)",
                detail: "Veuillez réessayer ultérieurement",
                life: 3000,
              })
            }
          } else {
            console.log(error)
            this.$toast.add({
              severity: "error",
              summary: "Impossible de récupérer le code du groupe (Firebase)",
              detail: "Veuillez réessayer ultérieurement",
              life: 3000,
            })
          }
        })
    },
    async fetchFirebase() {
      get(ref(db, `groups/${this.group.firebase_key}`))
        .then((dataSnapshot) => {
          const group = dataSnapshot.val()
          const referenceGroup = ref(db, `groups/${this.group.firebase_key}`)

          const isFirstEditing = typeof group.html === 'string'
          this.files = [
            {
              ref: child(referenceGroup, "html"),
              content: isFirstEditing ? group.html : '',
              code: 'html'
            },
            {
              ref: child(referenceGroup, "css"),
              content: isFirstEditing ? group.css : '',
              code: 'css'
            },
            {
              ref: child(referenceGroup, "js"),
              content: isFirstEditing ? group.js : '',
              code: 'js'
            },
          ]
        })
        .catch((error) => {
          console.log(error)
        })
        .finally(() => {
          this.isLoaded = true
        })
      ;
    },
    async checkAccess() {
      const userId = this.$store.state.auth.id
      const userInProject = this.group.project.members.find(member => member.id === userId)
      if (!userInProject) {
        await this.$router.push({ name: "401 Non autorisé" })
      }
    },
    sendCode() {
      if (this.isFinish) {
        this.$toast.add({
          severity: "error",
          summary: "Impossible d'envoyer le code",
          detail: "L'examen est terminé, le partage de code est donc bloqué",
          life: 3000,
        })
        return
      }

      axios.post(`groups/${this.$route.params.idGroup}/dispatch_teacher_code`, {
        group_id: this.group.id,
        files: this.previews
      })
        .then(() => {
          this.$toast.add({
            severity: "success",
            summary: "Code envoyé",
            detail: "Le code a bien été partagé avec les autres groupes",
            life: 3000,
          })
        })
        .catch(() => {
          this.$toast.add({
            severity: "error",
            summary: "Impossible d'envoyer le code",
            detail: "Veuillez réessayer ultérieurement",
            life: 3000,
          })
        })
    },
    updateNow() {
    	this.now = Date.now()
    },
  },
  async mounted() {
    await this.fetchGroupDetails()
    await this.checkAccess()
    await this.signInFirebase()

  	setInterval(this.updateNow.bind(this) , 1000)
  },
  beforeDestroy () {
    if (this.authFirebase) {
      signOut(this.authFirebase.auth)
    }
  }
}
</script>

<style lang="scss">
.separator {
  width: 1px;
  background-color: var(--text-light);
  height: 17.5px;
}

.previewMaximized {
  .editor-panel {
    flex-basis: 0 !important;
  }
  #code-editor {
    opacity: 0;
    height: 0;
  }
}

</style>
